import { Component, OnInit, EventEmitter, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/core/helper/common.service';
import { PmdSidebar } from 'src/app/shared/propeller';
import { LayoutService } from '../layout.service';
import { Location } from '@angular/common';
import { LoginService } from 'src/app/core/authentication/login.service';
import { CONSTANTS } from 'src/app/core/config/constants';
import { LocalStorageService } from 'src/app/core/helper/local-storage.service';
import { PusherService } from '../pusher.service';
import * as moment from 'moment';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  host: {
    class: 'container',
  }
})
export class NavbarComponent implements OnInit {

  @ViewChild(PmdSidebar) leftSidebar;

  headerData: any;
  showLoader: boolean = false;
  pusherClient:any;
  notificationObj={message:{
                            count:0,
                            message:[],
                          }}
  userObj:any;
    
  
  constructor(private router: Router,
    public commonService: CommonService,
    private layoutService: LayoutService,
    private location: Location,
    private loginService: LoginService,
    private localStorageService: LocalStorageService,
    private pusherService: PusherService,
  ) {
    
  }

  // languageForm: FormGroup;
  language = 'en';
  languages = [
    { id: 'en', name: 'English' },
    { id: 'sp', name: 'Spanish' },
    { id: 'fr', name: 'French' },
    { id: 'ar', name: 'Arabic' },
    { id: 'ru', name: 'Russian' }
  ];
  credentials = this.localStorageService.getLocalStorage('credentials');
  RememberMe = this.localStorageService.getLocalStorage('RememberMe');

  changeLang() {
    // console.log('===========change language======', this.language)
    this.commonService.changeLanguage(this.language)
  }

  ngOnInit() {
    this.userObj=this.localStorageService.getUser();
    console.log("userObj",this.userObj)
    this.pusherService.unsubscribePusher('notification_'+this.userObj.merchant_number);  
   
    //display invoice data
    this.layoutService.getMerchantViewHeaderData().subscribe({
      next: (response) => {
        this.headerData = response;
      },
      error: (e) => {
        this.commonService.handleSubscribeError(e);
      }
    });

    this.getNotificationList();
    this.pusherRealtimeNotificationUpdate();
  }

  /**
   * get notification list
   */
  getNotificationList(){
     this.layoutService.getNotificationList().subscribe({
      next: (response) => {
        const statusCode = this.commonService.handleSubscribeNext(response);
        switch (statusCode) {
          case CONSTANTS.API.RESPONSE.STATUS_CODE.SUCCESS:
            this.notificationObj={message:{
                            count:response.data.data.length,
                            message:response.data.data,
                          }}
            break;
          default:
            console.log("default case executed response")
            break;
        }

      }
    })
  }

  /**
   * pusher notification update count and text
   */
  pusherRealtimeNotificationUpdate(){
    var channel = this.pusherService.pusherClient.subscribe('notification_'+this.userObj.merchant_number);
    channel.bind('notification_count', (data:any) => {
      this.notificationObj.message.count=data.message.count;
      this.notificationObj.message.message.unshift(data.message.message);
      if (data.message.message.notification === "Admin Has Approved you KYC Details") {
        const userData = this.localStorageService.getUser();
        userData.is_kyc_verified = 1
        this.localStorageService.saveUser(userData)
        this.localStorageService.saveLocalStorage('kyc_details', {kyc_completed: true, show_verification_status: 1});
        this.localStorageService.saveLocalStorage('kyc_verified', 1);
      }
    });
    
  }

  /**
   * user logout 
   */
  logout(){
    this.showLoader = true;
    this.loginService.logout().subscribe({
      next: (response) => {
        this.showLoader = false;
        const statusCode = this.commonService.handleSubscribeNext(response);
        switch (statusCode) {
          case CONSTANTS.API.RESPONSE.STATUS_CODE.SUCCESS:
            if (this.RememberMe) {
              this.localStorageService.deleteAllLocalStorage();
              this.setCred(this.credentials, this.RememberMe);
            } else {
              this.localStorageService.deleteAllLocalStorage();
            }
            this.router.navigateByUrl("/"); 
            break;
          default:
            console.log("default case executed response")
            break;
        }
      },
      error: (e) => {
        this.showLoader = false;
        this.commonService.handleSubscribeError(e);
      }
    });
  }

  setCred(credentials, RememberMe) {
    if (RememberMe) {
      this.localStorageService.saveLocalStorage('credentials', credentials);
      this.localStorageService.saveLocalStorage('RememberMe', RememberMe);
    }
  }

  toggleSideBar() {
    // this.leftSidebar.toggleSideBar();
    this.commonService.sideBarToggle.emit();
  }

  backClicked() {
    this.location.back();
  }

  /**
   * notification time convert
   */
  notificationTimeConvert(date){
    return moment(date).fromNow();
  }
  
  /**
   * redirec to url
   * @param url 
   */
  redirectToUrl(data){
    let dataDto={
      notification_id:data.notification_id
    }
    this.layoutService.markAsReadNotification(dataDto).subscribe({
      next: (response) => {
        const statusCode = this.commonService.handleSubscribeNext(response);
        switch (statusCode) {
          case CONSTANTS.API.RESPONSE.STATUS_CODE.SUCCESS:
            window.location.href =data.redirection_path;
            break;
          default:
            console.log("default case executed response")
            break;
        }

      }
    })
   
  }
}
